import HeaderBar from "@/components/landing/HeaderBar";
import HeroSection from "@/components/landing/HeroSection";
import TrustBadge from "@/components/landing/TrustBadge";
import VideoSection from "@/components/landing/VideoSection";
import ProblemSection from "@/components/landing/ProblemSection";
import ModulesSection from "@/components/landing/ModulesSection";
import BonusSection from "@/components/landing/BonusSection";
import EducationSection from "@/components/landing/EducationSection";
import TestimonialsSection from "@/components/landing/TestimonialsSection";
import FlipbookSection from "@/components/landing/FlipbookSection";
import OfferSection from "@/components/landing/OfferSection";
import FAQSection from "@/components/landing/FAQSection";
import Footer from "@/components/landing/Footer";
import FloatingCTA from "@/components/landing/FloatingCTA";
import SocialProofNotification from "@/components/landing/SocialProofNotification";

const Index = () => {
  return (
    <main className="min-h-screen stars-bg">
      <HeaderBar />
      <div id="hero">
        <HeroSection />
      </div>
      <div id="video">
        <VideoSection />
      </div>
      <ProblemSection />
      <div id="modules">
        <ModulesSection />
      </div>
      <div id="bonus">
        <BonusSection />
      </div>
      <EducationSection />
      <div id="testimonials">
        <TestimonialsSection />
      </div>
      <FlipbookSection />
      <div id="offer">
        <OfferSection />
      </div>
      <TrustBadge />
      <FAQSection />
      <Footer />
      <FloatingCTA />
      <SocialProofNotification />
    </main>
  );
};

export default Index;
